
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[ActivitySlug]/details/[ActivityId]/reviews",
      function () {
        return require("private-next-pages/[ActivitySlug]/details/[ActivityId]/reviews.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[ActivitySlug]/details/[ActivityId]/reviews"])
      });
    }
  